import { React,  DomeComponent, DomeManipulator } from '@lexriver/dome'
import css from './Input.m.scss'
import { ErrorForInput } from './ErrorForInput'
import { ButtonIcon } from './ButtonIcon'
import { EnumIconNames } from '../../enums/EnumIconNames'


interface Attrs{
    inputType?:'text' | 'password' | 'date' | 'datetime-local'
    value?:string
    onEnterKeypress?:(text:string)=>void
    onInput?:(text:string)=>void
    onBlur?:(text:string)=>void
    sessionStorageKey?:string
    passwordIsVisible?:boolean
    placeholder?:string
}
export class Input extends DomeComponent<Attrs>{
    private refErrorForInput:ErrorForInput|undefined 
    private refInput:HTMLInputElement|undefined
    render(){
        if(this.attrs.sessionStorageKey){
            this.attrs.value = sessionStorage.getItem(this.attrs.sessionStorageKey) || this.attrs.value || ''
        }
        let inputType = this.attrs.inputType || 'text'
        if(this.attrs.passwordIsVisible) inputType = 'text'
        return (
            <div class={css.input}>
                <input 
                    type={inputType} 
                    onInput={(e) => this.onInputAsync(e)} 
                    value={this.attrs.value || undefined} 
                    placeholder={this.attrs.placeholder}
                    ref={(ref:HTMLInputElement) => this.refInput = ref }/>

                {this.attrs.inputType === 'password' && !this.attrs.passwordIsVisible &&
                    <ButtonIcon iconName={EnumIconNames.Eye} onClick={(e) => {e.preventDefault(); this.showPasswordClick(); }} />
                }

                {this.attrs.inputType === 'password' && this.attrs.passwordIsVisible &&
                    <ButtonIcon iconName={EnumIconNames.EyeOff} onClick={(e) => {e.preventDefault(); this.hidePasswordClick(); }} />
                }
                
                <ErrorForInput ref={ref => this.refErrorForInput = ref} />
            </div>
        )
    }

    afterRender(){
        if(!this.refInput) return
        if(this.attrs.onEnterKeypress){
            this.refInput.addEventListener('keypress', (e) => {
                if(!this.refInput) return
                if(!this.attrs.onEnterKeypress) return
                if(e.keyCode === 13 || e.key === 'Enter'){
                    this.attrs.onEnterKeypress(this.refInput.value)
                }
            })
        }
        if(this.attrs.onBlur){
            this.refInput.addEventListener('blur', () => {
                if(!this.refInput) return
                if(!this.attrs.onBlur) return
                this.attrs.onBlur(this.refInput.value)
            })
        }

    }

    showPasswordClick(){
        //console.log('showPasswordClick')
        this.attrs.passwordIsVisible = true
        this.scheduleUpdate()
    }

    hidePasswordClick(){
        //console.log('hidePasswordClick')
        this.attrs.passwordIsVisible = false
        this.scheduleUpdate()
    }

    async onInputAsync(e){
        //console.log('on input', e.target.value)
        //TODO: move to onBlur event?
        this.attrs.value = e.target.value
        if(this.attrs.sessionStorageKey){
            sessionStorage.setItem(this.attrs.sessionStorageKey, this.attrs.value || '')
        }
        if(this.attrs.onInput){
            this.attrs.onInput(e.target.value)
        }
        await this.hideErrorAsync()
    }

    async hideErrorAsync(){
        if(!this.refErrorForInput) return
        await this.refErrorForInput.hideAsync()
    }

    async showErrorAsync(errorMessage:string|HTMLElement){
        if(!this.refErrorForInput) return
        if(!this.refInput) return
        await this.refErrorForInput.showAsync(errorMessage)
        DomeManipulator.scrollIntoView(this.refInput)
    }

    getValue(){
        return this.attrs.value
    }

    clear(){
        this.setValue(null)
    }

    setValue(newValue:string|number|null|undefined){
        if(newValue === undefined) newValue = ''
        else if(newValue === null) newValue = ''
        newValue = newValue.toString()
        this.attrs.value = newValue
        if(this.attrs.sessionStorageKey){
            sessionStorage.setItem(this.attrs.sessionStorageKey, newValue)
        }
        if(!this.refInput) return
        this.refInput.value = newValue
    }



    focus(){
        if(this.refInput) this.refInput.focus()
    }

    disable(){
        if(this.refInput) this.refInput.disabled = true
    }

    enable(){
        if(this.refInput) this.refInput.disabled = false
    }
    
}